import { listenClickOutside } from '@/natives/libs/utils';

/**
 * 基于指定dom的位置打开下拉选择框
 * @param {HTMLElement} dom
 * @param {any[]} list
 */
export default function createSelectDropdown(dom, list) {
  // 下拉框最多可见项
  const DROPDOWN_NUM_MAX = 8;
  // 下拉框最大高度
  const DROPDOWN_HEIGHT_MAX = DROPDOWN_NUM_MAX * 32;
  // 吸附间距
  const ATTACH_GAP = 8;

  let selected = -1;
  let hovering = -1;
  /**
   * @type {HTMLInputElement}
   */
  let elInput = dom.querySelector('.hpp-select__input');
  /**
   * @type {HTMLSpanElement}
   */
  let elSpan = dom.querySelector('.hpp-select__input_span');
  /**
   * @type {{index: number, label: string, el: HTMLParagraphElement}[]}
   */
  const children = [];
  /**
   * @type {{index: number, label: string, el: HTMLParagraphElement}[]}
   */
  let filtered = [];

  // 创建元素
  const elDropdown = document.createElement('div');
  elDropdown.classList.add('hpp-select-dropdown', 'hidden');

  list.forEach(({ index, label }) => {
    const el = document.createElement('p');
    el.classList.add('hpp-select-dropdown__item');
    el.textContent = label;
    children.push({ index, label, el });
    filtered = children;
    elDropdown.appendChild(el);
  });

  const updateList = (search) => {
    elDropdown.textContent = '';
    filtered = children;
    if (search) {
      filtered = children.filter((child) => child.label.toLowerCase().includes(search.toLowerCase()));
    }
    filtered.forEach((item) => {
      elDropdown.appendChild(item.el);
    });
  };

  const listeners = {
    select: [],

    trigger(eventName, ...args) {
      const fns = this[eventName] || [];
      for (const fn of fns) {
        fn(...args);
      }
    }
  };

  const scrollToIndex = (index) => {
    if (index === -1) {
      return;
    }
    const child = filtered.find((child) => child.index === index);
    child.el.scrollIntoView(false);
  };

  const setStyle = () => {
    elDropdown.style.maxHeight = `${DROPDOWN_HEIGHT_MAX }px`;
    const attachDomRect = dom ? dom.getBoundingClientRect() : {};
    elDropdown.style.position = 'fixed';
    elDropdown.style.top = `${attachDomRect.bottom + ATTACH_GAP }px`;
    elDropdown.style.left = `${attachDomRect.left }px`;
    elDropdown.style.right = '';

    const rect = elDropdown ? elDropdown.getBoundingClientRect() : {};
    if (rect.left + rect.width > window.innerWidth) {
      elDropdown.style.left = '';
      elDropdown.style.right = `${ATTACH_GAP }px`;
    }
  };

  const switchInput = () => {
    const spanRect = elSpan ? elSpan.getBoundingClientRect() : {};
    elInput.style.width = `${spanRect.width }px`;
    elSpan.style.display = 'none';
    elInput.style.display = 'block';
    elInput.select();
  };

  const switchSpan = () => {
    elSpan.style.display = 'block';
    elInput.style.display = 'none';
    elInput.value = elSpan.textContent;
    updateList();
  };

  const open = () => {
    elDropdown.classList.toggle('hidden', false);
    // 因宽度是根据内容自适应的，所以要显示出来后计算一次位置
    setStyle();
    // 将span标签切换为input标签
    switchInput();
    // 显示后自动滚动到selected那一项
    scrollToIndex(selected);
    // 根据selected计算初始hover项的位置
    const arrayIndex = filtered.findIndex((child) => child.index === selected);
    hovering = arrayIndex >= DROPDOWN_NUM_MAX ? arrayIndex - DROPDOWN_NUM_MAX : -1;
  };
  const close = () => {
    elDropdown.classList.toggle('hidden', true);
    // 去除所有hover样式
    children.forEach((item) => item.el.classList.toggle('hover', false));
    hovering = -1;
    // 将input标签切换为span标签
    switchSpan();
  };
  const setSelectedClass = (index) => {
    for (const child of children) {
      if (child.index === index) {
        child.el.classList.toggle('selected', true);
      } else {
        child.el.classList.toggle('selected', false);
      }
    }
  };
  const updateText = (index) => {
    const label = list.find((item) => item.index === index)?.label;
    elSpan.textContent = label;
    elInput.value = label;
  };
  const select = (index) => {
    selected = index;
    setSelectedClass(index);
    updateText(index);
    listeners.trigger('select', index);
  };

  /**
   * 事件监听
   */

  // 列表项点击事件
  const onItemClick = (index) => {
    select(index);
    close();
  };
  children.forEach((child) => child.el.addEventListener('click', () => onItemClick(child.index)));
  // 列表项鼠标放上事件
  const onItemHover = (event) => {
    filtered.forEach((item, index) => {
      item.el.classList.toggle('hover', false);
      if (item.el === event.target) {
        item.el.classList.toggle('hover', true);
        hovering = index;
      }
    });
  };
  children.forEach((child) => child.el.addEventListener('mouseenter', onItemHover));
  // 点击组件显示下拉列表
  dom.addEventListener('click', open);
  // 点击外面关闭下拉列表
  listenClickOutside(elDropdown, close, [dom]);
  // 输入搜索词时更新下拉列表
  elInput.addEventListener('input', () => {
    updateList(elInput.value);
    hovering = -1;
  });
  // 监听按键事件
  const onArrowKeydown = (event) => {
    event.preventDefault();
    filtered[hovering]?.el.classList.toggle('hover', false);
    if (event.code === 'ArrowDown') {
      if (filtered.length - 1 > hovering) {
        hovering++;
      }
    } else if (event.code === 'ArrowUp') {
      if (hovering > 0) {
        hovering--;
      }
    }
    filtered[hovering]?.el.classList.toggle('hover', true);
    if (filtered[hovering]?.el) {
      const viewTop = filtered[hovering].el.offsetTop - elDropdown.scrollTop;
      if (viewTop < 0) {
        filtered[hovering].el.scrollIntoView();
      } else if (viewTop >= 256) {
        filtered[hovering].el.scrollIntoView(false);
      }
    }
  };
  const onEnterKeydown = () => {
    const child = filtered[hovering];
    if (child) {
      child.el.click();
    } else {
      filtered[0].el.click();
    }
  };
  elInput.addEventListener('keydown', (event) => {
    switch (event.code) {
      case 'ArrowDown':
      case 'ArrowUp':
        onArrowKeydown(event);
        break;
      case 'Enter':
      case 'NumpadEnter':
        onEnterKeydown();
        break;
      default:
        break;
    }
  });

  document.body.appendChild(elDropdown);

  return {
    open,
    close,
    select,
    on(eventName, fn) {
      if (!listeners[eventName]) {
        listeners[eventName] = [];
      }
      listeners[eventName].push(fn);
    },
    get dropdownEl() {
      return elDropdown;
    },
    get selected() {
      return selected;
    }
  };
}
